import yup from "yup";
import { compose, withProps } from "recompose";
import { createStructuredSelector } from "reselect";
import { parse } from "query-string";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { withActions } from "core/redux/hoc";
import { createErrorsSelector } from "core/helpers";
import * as mixpanel from "core/integrations/mixpanel";
import * as api from "modules/user/auth/api";
import * as selectors from "modules/user/auth/selectors";
import { unauthenticated } from "modules/user/auth/hoc";
import View from "./View";

export default compose(
  unauthenticated,
  withRouter,
  withProps(({ location }) => ({
    backUrl: parse(location.search).redirect
  })),
  connect(
    createStructuredSelector({
      signInApi: selectors.signInApi,
      linkedInSignInApi: selectors.linkedInSignInApi,
      errors: createErrorsSelector(
        selectors.signInApi,
        selectors.linkedInSignInApi
      )
    })
  ),
  withActions({
    onSubmit: ({ backUrl }) => values => {
      mixpanel.trackEvent("login button clicked", {});
      return api.signIn.request({ body: values, backUrl });
    },
    onSignInSuccess: ({ backUrl }) => () =>
      api.linkedInSignIn.request({
        body: { access_token: window.IN.ENV.auth.oauth_token },
        backUrl
      })
  }),

  withProps({
    validationSchema: yup.object().shape({
      email: yup
        .string()
        .required("Email is required")
        .email("Is not valid email"),
      password: yup
        .string()
        .required("Password is required")
        .min(8, "Password should be at least 8 characters length")
    })
  })
)(View);



// WEBPACK FOOTER //
// ./src/components/pages/Auth/Login/Provider.js